export enum EPostHogEventName {
  // Invite
  INVITE_INVESTOR_TO_ORGANIZATION = "invite_investor_to_organization",

  // Search
  HEADER_SEARCH_COMPANIES = "header_search_companies",
  DISCOVER_SEARCH_COMPANIES = "discover_search_companies",

  // Add companies
  ADD_COMPANIES = "add_companies",
  DISCOVER_ADD_TO_PIPELINE = "discover_add_to_pipeline",
}
